import React from "react";
import {
  Box,
  Typography,
  ToggleButton,
  ToggleButtonGroup,
} from "@mui/material";

const ChooseMode = ({ value, onChange }) => {
  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#f5f7fa",
        p: 2,
      }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: 600,
          textAlign: "center",
          backgroundColor: "#fff",
          borderRadius: 4,
          p: 5,
          boxShadow: 4,
        }}
      >
        <Typography variant="h4" mb={4} fontWeight="bold" color="primary">
          Choose Mode
        </Typography>

        <ToggleButtonGroup
          value={value}
          exclusive
          onChange={(e, newValue) => newValue && onChange(newValue)}
          fullWidth
          sx={{
            "& .MuiToggleButton-root": {
              borderRadius: 2,
              textTransform: "none",
              fontWeight: 500,
              fontSize: "1.1rem",
              p: 2,
              transition: "0.3s",
              border: "1px solid #ccc",
              "&.Mui-selected": {
                backgroundColor: "#1976d2",
                color: "#fff",
                borderColor: "#1976d2",
              },
              "&:hover": {
                backgroundColor: "#e3f2fd",
              },
            },
          }}
        >
          <ToggleButton value="single">Continue with Single Item</ToggleButton>
          <ToggleButton value="group">Continue with Group Items</ToggleButton>
        </ToggleButtonGroup>
      </Box>
    </Box>
  );
};

export default ChooseMode;
